import { render } from "./FilePpt.vue.js?vue&type=template&id=12dc49ff!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FilePpt.vue?vue&type=template&id=12dc49ff"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__